import { render, staticRenderFns } from "./GiftsAmendment.vue?vue&type=template&id=54586f00"
import script from "./GiftsAmendment.vue?vue&type=script&lang=js"
export * from "./GiftsAmendment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports